import { render, staticRenderFns } from "./WaitingTable.vue?vue&type=template&id=1293644e"
import script from "./WaitingTable.vue?vue&type=script&lang=js"
export * from "./WaitingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports